import { render, staticRenderFns } from "./DetailConfigDatasetList.vue?vue&type=template&id=1dd45f6c"
import script from "./DetailConfigDatasetList.vue?vue&type=script&lang=js"
export * from "./DetailConfigDatasetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports